// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "app" + "." + "e5b9de8531d3721b8229" + ".css";
};